import { Partner } from 'types';

export const checkIsPartnerCoOwner = (partner: Partner) =>
  (partner?.sharesBurdenCount?.coOwnerPrimary || 0) +
    (partner?.sharesBurdenCount?.coOwnerSecondary || 0) +
    (partner?.sharesBurdenCount?.usufruct || 0) +
    (partner?.sharesBurdenCount?.otherBurdens || 0) >
  0;
